
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { GameTypeMapper } from "../../constants/gameTypes/GameTypeMapper";
import { PokerGameTypes } from "../../constants/PokerGameTypes";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2LobbyDetailEvent } from "../../event/Poker2LobbyDetailEvent";
import { Poker2TournamentDataEvent } from "../../event/Poker2TournamentDataEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SeatVO } from "../../gamevo/SeatVO";
import { TournamentInfoLineVO } from "../../gamevo/TournamentInfoLineVO";
import { TournamentLobbyDetailVO } from "../../gamevo/TournamentLobbyDetailVO";
import { TournamentResultVO } from "../../gamevo/TournamentResultVO";
import { TournamentTableVO } from "../../gamevo/TournamentTableVO";
import { TournamentVO } from "../../gamevo/TournamentVO";
import { Poker2StandardOkDialog } from "../../view/dialogs/Poker2StandardOkDialog";
import { Poker2TourInvitationDialog } from "../../view/dialogs/tournament/Poker2TourInvitationDialog";
import { Poker2TourInvitationDialogProperties } from "../../view/dialogs/tournament/Poker2TourInvitationDialogProperties";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";
import { Poker2Model } from "../Poker2Model";
import { BasicData } from "./BasicData";

export class Poker2TournamentData extends BasicData {
    public tournamentList: LobbyTablesVO[];
    public tournamentInfoList: TournamentInfoLineVO[];
    public currentTournamentTable: LobbyTablesVO;
    public tournamentTables: TournamentTableVO[];
    public communityCards: any[] = new Array();
    private tournamentStartTime: number = -1;
    private _selectedTournament: number = 0;
    private _tournamentPot: number = 0;
    private _remainingPlayers: number = 0;
    private _allPlayers: number = 0;
    private _nextRoundTime: number = NaN;
    private _tournementData: any[];
    private _spectatorTournamentId: number = 0;
    private _selectedTournamentVO: TournamentVO;

    constructor() {
        super();
        this._tournementData = null;
        this.currentTournamentTable = new LobbyTablesVO(); // init an ampety vo incase JJI or JTS comes too slow
    }

    /**
     *  S2C_JOUST_LIST
     **/
    public parse_JLI(paramObject: any): void {
        if (!paramObject)
            return;
        this.parseTournamentList(paramObject.L);
    }

    /**
     *  S2C_JOUST_REGISTER
     **/
    public parse_JRE(paramObject: any): void {
        if (!paramObject)
            return;
        Poker2LayoutManager.getInstance().showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("dialog_tournament_register_titel", [paramObject.name]), Poker2Model.languageData.getTextById("dialog_tournament_register_copy", [paramObject.name])));
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("registerTournament", [paramObject.id, paramObject.name]));

    }

    /**
     *  S2C_JOUST_UNREGISTER
     **/
    public parse_JUR(paramObject: any): void {
        if (!paramObject)
            return;
        Poker2LayoutManager.getInstance().showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("dialog_tournament_unregister_titel", [paramObject.name]), Poker2Model.languageData.getTextById("dialog_tournament_unregister_copy", [paramObject.name])));
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("unregisterTournament", [paramObject.id, paramObject.name]));
    }

    /**
     *  S2C_JOUSTTABLE_LIST
     **/
    public parse_JTS(paramObject: any): void {
        if (!paramObject)
            return;
        this._selectedTournament = int(paramObject.id);
        this.tournamentPot = int(paramObject.p);
        this.remainingPlayers = int(paramObject.rp);
        this.allPlayers = int(paramObject.tp);
        this.nextRoundTime = paramObject.nr;
        this.parseTableList(paramObject.L);
        this.currentTournamentTable = new LobbyTablesVO();
    }

    /**
     *  S2C_JOUST_INFO
     **/
    public parse_JIO(paramObject: any): void {
        if (!paramObject)
            return;
        var tournamentLobbyDetailVO: TournamentLobbyDetailVO = new TournamentLobbyDetailVO();
        tournamentLobbyDetailVO.id = int(paramObject.id);
        tournamentLobbyDetailVO.name = paramObject.name;
        tournamentLobbyDetailVO.type = int(paramObject.type);
        tournamentLobbyDetailVO.start = paramObject.start;
        tournamentLobbyDetailVO.playerCount = int(paramObject.cp);
        tournamentLobbyDetailVO.itemId = int(paramObject.itemId);
        tournamentLobbyDetailVO.state = int(paramObject.status);
        tournamentLobbyDetailVO.rank = paramObject.rank;
        tournamentLobbyDetailVO.potChips = paramObject.potChips;
        tournamentLobbyDetailVO.potGold = paramObject.potGold;
        this.parseTournamentInfoList(paramObject.L);
        tournamentLobbyDetailVO.payOut = this.tournamentInfoList;
        tournamentLobbyDetailVO.pointsMultiplier = paramObject.pointsMultiplier;

        if (paramObject.update == false) {
            this.controller.dispatchEvent(new Poker2LobbyDetailEvent("showTournamentDetail", tournamentLobbyDetailVO));
        }
        else if (paramObject.update == true) {
            tournamentLobbyDetailVO.update = true;
            this.controller.dispatchEvent(new Poker2LobbyDetailEvent("showTournamentDetail", tournamentLobbyDetailVO));
        }
    }

    private parseTournamentInfoList(paramArray: any[]): void {
        this.tournamentInfoList = [];

        if (paramArray)
            if (paramArray != null) {
                for (let entryList of paramArray) {
                    var tableLine: any = entryList;
                    if (tableLine === undefined) continue;

                    var tournamentInfoLineVO: TournamentInfoLineVO = new TournamentInfoLineVO();
                    tournamentInfoLineVO.rank = tableLine.shift();
                    tournamentInfoLineVO.chips = tableLine.shift();
                    tournamentInfoLineVO.gold = tableLine.shift();
                    this.tournamentInfoList.push(tournamentInfoLineVO);
                }
            }
    }

    /**
     *  S2C_JOUSTTABLE_JOIN
     * Als Zuschauer, type 2
     **/
    public parse_JTJ(paramObject: any): void {
        if (!paramObject) {
            return;
        }

        // Map tables status to according to the given tournament type and build lobby table vos
        Poker2Model.onTableData.buildLobbyTableVOsAndSeatVOs(paramObject, GameTypeMapper.mapTournamentType(paramObject.type, true));
    }

    /**
     *  S2C_JOUST_JOIN
     * Als Teilnehmer, type 1
     **/
    public parse_JJN(paramObject: any): void {
        if (!paramObject) {
            return;
        }

        this._selectedTournament = int(paramObject.jid);

        // Map tables status to according to the given tournament type and build lobby table vos
        Poker2Model.onTableData.buildLobbyTableVOsAndSeatVOs(paramObject, GameTypeMapper.mapTournamentType(paramObject.type, false));
    }

    /**
     *  S2C_JOUST_INVITATION
     **/
    public parse_JJI(paramObject: any): void {
        if (!paramObject)
            return;
        this.currentTournamentTable = new LobbyTablesVO();
        this.currentTournamentTable.id = paramObject.tid;
        this.currentTournamentTable.name = paramObject.name;

        // TODO Server muß mir hier die actionTime schicken, dann kann das else weg
        if (paramObject.actiontime)
            this.currentTournamentTable.actionTime = int(paramObject.actiontime);
        else
            this.currentTournamentTable.actionTime = 20;
        Poker2LayoutManager.getInstance().showDialog("Poker2TourInvitationDialog", new Poker2TourInvitationDialogProperties(paramObject.id, paramObject.runtime, paramObject.name, paramObject.round));
    }

    /**
     *  S2C_JOUST_NEXT
     **/
    public parse_JNX(paramObject: any): void {
        if (!paramObject)
            return;
        this.tournamentTimeLeft(paramObject.start);
        this._tournementData = [paramObject.status, paramObject.id, paramObject.chips, paramObject.gold, paramObject.name];
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("changeNextTournament", this._tournementData));
    }

    public get tournementData(): any[] {
        return this._tournementData;
    }

    public parse_JEN(paramObject: any): TournamentResultVO {
        if (!paramObject)
            return null;
        var tournamentResultVO: TournamentResultVO = new TournamentResultVO();
        tournamentResultVO.name = paramObject.name;
        tournamentResultVO.rank = int(paramObject.rank);
        tournamentResultVO.chips = paramObject.chips;
        tournamentResultVO.gold = paramObject.gold;
        tournamentResultVO.tournamentPoints = int(paramObject.tp);

        // check if itemid is defined if it's a valid id (-1 stands for no item)
        if (paramObject.itemid && paramObject.itemid > -1) {
            var obj: any = {};
            // TODO: check if "0" as colorId is correct; it has to be "-1" -> no color available ?!
            //				obj.L = [[paramObject.itemid,0]];
            obj.L = [[paramObject.itemid, -1]];
            BasicController.commandDict.get("sbu").executeCommand(0, [0, JSON.stringify(obj)]);
        }

        tournamentResultVO.gameType = PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT;
        if (Poker2Model.onTableData.currentTable) {
            Poker2Model.onTableData.currentTable.tournamentInProgress = false;
        }
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("tournamentEnd", []));
        return tournamentResultVO;
    }

    public parse_JZO(paramObject: any): void {
        if (!paramObject)
            return;
        var seatVO: SeatVO = Poker2Model.onTableData.getSeatVOByIndex(paramObject.index);
        seatVO.zombie = int(paramObject.z);
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("changeZombie", [paramObject.z, paramObject.index]));
    }

    /**
     *  S2C_JOUST_SETBLIND
     **/
    public parse_JSB(paramObject: any): void {
        if (!paramObject)
            return;
        if (this.currentTournamentTable)
            this.currentTournamentTable.sBlind = int(paramObject.b);
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("tournamentSetBlind", [paramObject.b]));
    }

    public getTournamentTableById(id: number): LobbyTablesVO {

        if (this.tournamentList != null) {
            for (let entryList of this.tournamentList) {
                var tournamentTable: any = entryList;
                if (tournamentTable === undefined) continue;

                if (tournamentTable.tournamentVO.id == id)
                    return tournamentTable;
            }
        }
        return null;
    }

    public getTournamentNameById(id: number): string {
        if (this.tournamentList != null) {
            for (let entryList of this.tournamentList) {
                var tournamentTable: any = entryList;
                if (tournamentTable === undefined) continue;

                if (tournamentTable.tournamentVO.id == id)
                    return tournamentTable.tournamentVO.name;
            }
        }
        return "";
    }

    private parseTournamentList(paramArray: any[]): void {
        this.tournamentList = [];

        if (paramArray)
            if (paramArray != null) {
                for (let entryList of paramArray) {
                    var tableLine: any = entryList;
                    if (tableLine === undefined) continue;

                    var lobbyTablesVO: LobbyTablesVO = new LobbyTablesVO();
                    lobbyTablesVO.tournamentVO = new TournamentVO();
                    lobbyTablesVO.tournamentVO.id = tableLine.shift();
                    lobbyTablesVO.tournamentVO.name = tableLine.shift();
                    lobbyTablesVO.tournamentVO.chipsFee = tableLine.shift();
                    lobbyTablesVO.tournamentVO.goldFee = tableLine.shift();
                    lobbyTablesVO.tournamentVO.status = tableLine.shift();
                    lobbyTablesVO.tournamentVO.startTime = tableLine.shift();
                    lobbyTablesVO.tournamentVO.currentPlayers = tableLine.shift();
                    lobbyTablesVO.tournamentVO.maxPlayers = tableLine.shift();
                    lobbyTablesVO.tournamentVO.pot = tableLine.shift();
                    this.tournamentList.push(lobbyTablesVO);
                }
            }
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("changeTournamentData"));
    }

    private parseTableList(paramArray: any[]): void {
        this.tournamentTables = [];

        if (paramArray)
            if (paramArray != null) {
                for (let entryList of paramArray) {
                    var tableLine: any = entryList;
                    if (tableLine === undefined) continue;

                    var tournamentTableVO: TournamentTableVO = new TournamentTableVO();
                    tournamentTableVO.id = int(tableLine.shift());
                    tournamentTableVO.tableName = tableLine.shift();
                    tournamentTableVO.tableWinner = tableLine.shift();
                    tournamentTableVO.currentPlayers = int(tableLine.shift());
                    tournamentTableVO.spectators = int(tableLine.shift());
                    this.tournamentTables.push(tournamentTableVO);
                }
            }
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("tournamentTableList"));
    }

    public getLobbyTableById(id: number): TournamentTableVO {
        if (this.tournamentTables != null) {
            for (let entryList of this.tournamentTables) {
                var lobbyTable: any = entryList;
                if (lobbyTable === undefined) continue;

                if (lobbyTable.id == id)
                    return lobbyTable;
            }
        }
        return null;
    }

    public tournamentTimeLeft(leftTime: number): void {
        if (leftTime < 0)
            this.tournamentStartTime = -1;
        else {
            this.tournamentStartTime = Date.now() / 1000 + leftTime;
        }
    }

    public get activeTournamentStartTime(): number {
        return this.tournamentStartTime - Date.now() / 1000;
    }

    public update(): void {
        if (this.tournamentStartTime != -1)
            BasicController.getInstance().dispatchEvent(new Poker2TournamentDataEvent("nextTournamentStarttime", [this.activeTournamentStartTime]));
    }

    public get selectedTournament(): number {
        return this._selectedTournament;
    }

    public get tournamentPot(): number {
        return this._tournamentPot;
    }

    public set tournamentPot(value: number) {
        this._tournamentPot = value;
    }

    public get remainingPlayers(): number {
        return this._remainingPlayers;
    }

    public set remainingPlayers(value: number) {
        this._remainingPlayers = value;
    }

    public get nextRoundTime(): number {
        return this._nextRoundTime;
    }

    public set nextRoundTime(value: number) {
        this._nextRoundTime = value;
    }

    public get allPlayers(): number {
        return this._allPlayers;
    }

    public set allPlayers(value: number) {
        this._allPlayers = value;
    }

    public get selectedTournamentVO(): TournamentVO {
        return this._selectedTournamentVO;
    }

    public set selectedTournamentVO(value: TournamentVO) {
        this._selectedTournamentVO = value;
    }

	/*public function get spectatorTournamentId():int
	{
		return _spectatorTournamentId;
	}

	public function set spectatorTournamentId( value:int ):void
	{
		_spectatorTournamentId = value;
	}*/

}
